/* Componente Contactos - Solo Lógica */
import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { MapPin, Mail, Phone, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import ContactosUI from '../ui/Contactos_UI';

const Contactos = () => {
  const { language, translations } = useContext(LanguageContext);
  const t = translations[language];

  // Datos de información de contacto
  const contactInfo = [
    {
      icon: <MapPin className="w-6 h-6 text-black" />,
      title: t.location,
      content: (
        <>
          {t.locationDescription1},<br />
          {t.locationDescription2},<br />
          EPN (Quito, Ecuador)
        </>
      )
    },
    {
      icon: <Mail className="w-6 h-6 text-black" />,
      title: t.email,
      content: (
        <>
          ata.rg@epn.edu.ec<br />
          esteban.valencia@epn.edu.ec
        </>
      )
    },
    {
      icon: <Phone className="w-6 h-6 text-black" />,
      title: t.phone,
      content: '+593 996 645 322'
    }
  ];

  // Datos de redes sociales (ahora usando solo lucide)
  const socialLinks = [
    { 
      icon: <Facebook className="w-5 h-5 text-gray-700 hover:text-blue-600" />, 
      url: 'https://www.facebook.com/ATAResearch', 
      bg: 'hover:bg-blue-50'
    },
    { 
      icon: <Twitter className="w-5 h-5 text-gray-700 hover:text-black" />, 
      url: 'https://x.com/AtaResearch', 
      bg: 'hover:bg-gray-100'
    },
    { 
      icon: <Instagram className="w-5 h-5 text-gray-700 hover:text-pink-600" />, 
      url: 'https://www.instagram.com/ata_research_group/', 
      bg: 'hover:bg-pink-50'
    },
    { 
      icon: <Linkedin className="w-5 h-5 text-gray-700 hover:text-blue-700" />, 
      url: 'https://www.linkedin.com/company/ata-research-group1', 
      bg: 'hover:bg-blue-50'
    }
  ];

  return (
    <ContactosUI 
      t={t}
      contactInfo={contactInfo}
      socialLinks={socialLinks}
    />
  );
};

export default Contactos;
